import { useEffect, useState } from "react";
import { getVip } from "@/lib/api";

export const useVip = () => {
  const [code, setCode] = useState(getVip());
  useEffect(() => {
    const on = () => setCode(getVip());
    window.addEventListener("vip-change", on);
    return () => window.removeEventListener("vip-change", on);
  }, []);
  return code;
};
